import { connect } from 'react-redux'
import Component from 'components/JobLabourRates/Filter'

export default connect()(Component)
